import ReadMoreButton from '../../../components/buttons/readMoreButton/readMoreButton';
import NormalText from '../../../components/text/normalText';
import './productCardStyle.css';

export default function ProductCard({product}) {
    return (
        <article className='product-card__container'>
            <h1 className='product-card__title'>{product.name}</h1>
            <img className='product-card__photo' src={product.photo} alt="" />
            <NormalText text={product.summary} />
            <ReadMoreButton url={`/products/${product.id}`} />
        </article>
    );
}
